import { render } from "./showDocument.vue?vue&type=template&id=fc1041ce&scoped=true"
import script from "./showDocument.vue?vue&type=script&lang=js"
export * from "./showDocument.vue?vue&type=script&lang=js"

import "./showDocument.vue?vue&type=style&index=0&id=fc1041ce&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc1041ce"]])

export default __exports__